// SVG wordmark logo for XCARET MEXICO transportation.
export const Logo = ({ variant = "dark", className = "" }) => {
  const primary = variant === "light" ? "#FDFBF7" : "#0F2922";
  const accent = "#00A896";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg width="38" height="38" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="23" stroke={accent} strokeWidth="2" />
        {/* stylized X formed by two palm-like strokes */}
        <path d="M14 14 L34 34" stroke={accent} strokeWidth="3" strokeLinecap="round" />
        <path d="M34 14 L14 34" stroke={primary} strokeWidth="3" strokeLinecap="round" />
        {/* wave at bottom */}
        <path d="M11 33 Q16 30 21 33 T31 33 T41 33" stroke={accent} strokeWidth="1.6" fill="none" strokeLinecap="round" opacity="0.8" />
      </svg>
      <div className="leading-none">
        <span
          className="font-heading font-semibold text-lg tracking-wide block"
          style={{ color: primary }}
        >
          XCARET<span style={{ color: accent }}> MEXICO</span>
        </span>
        <span
          className="font-body text-[10px] tracking-[0.25em] uppercase block mt-0.5"
          style={{ color: variant === "light" ? "rgba(253,251,247,0.7)" : "#5C756B" }}
        >
          Transportation
        </span>
      </div>
    </div>
  );
};
